import * as React from "react";
import type { SVGProps } from "react";

interface ParryProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Parry = ({ cancelled = false, ...props }: ParryProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        d="M20.65 5.25C21.95 5.25 23 6.3 23 7.6v10.94c0 .69-.56 1.25-1.25 1.25h-.37c-.62 0-1.13-.45-1.23-1.04H3.35c-.1.55-.54.98-1.1 1.03h-.5c-.69 0-1.25-.55-1.25-1.24V7.6c0-1.3 1.05-2.35 2.35-2.35Z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M20.65 6c.88 0 1.6.72 1.6 1.6v10.94a.5.5 0 0 1-.5.5h-.37a.5.5 0 0 1-.5-.5V7.6c0-.13-.1-.23-.23-.23H2.85c-.13 0-.23.1-.23.23v10.94a.5.5 0 0 1-.5.5h-.37a.5.5 0 0 1-.5-.5V7.6c0-.88.72-1.6 1.6-1.6z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M11.58 4.25h-.16c-.53.05-.93.3-1.17.71l-.06.11-.1-.04a1.9 1.9 0 0 0-.6-.09h-.15c-.56.05-1 .32-1.24.76l-.02.03-.1-.03c-.17-.06-.37-.1-.58-.1-.9 0-1.5.56-1.63 1.46v.1l-.01 6.94v.08c-.02.85 0 1.36.14 1.97.15.67.43 1.26.87 1.76a4.73 4.73 0 0 0 3.96 1.84c1.15 0 2.23-.48 3.24-1.4l4.93-4.69.08-.08c.41-.52.36-1.19-.2-1.58-.7-.5-1.53-.64-2.42-.55l-.18.03c-.24.05-.49.14-.74.26l-.12.07V6.5l-.03-.2c-.22-.84-.8-1.36-1.63-1.36h-.15c-.16.02-.3.05-.43.1l-.1.04-.05-.11a1.49 1.49 0 0 0-1.35-.72"
      />
      <path
        fill="#007BBD"
        fillRule="nonzero"
        d="M11.58 5c.53 0 .82.3.9.9v5.43h.34V6.5c.1-.54.38-.8.84-.8s.77.26.9.8v6.81c.73-.68 1.36-1.05 1.88-1.11.57-.06 1.3-.02 1.9.41.2.13.2.3.05.5l-4.73 4.5c-.94.93-1.92 1.39-2.93 1.39-1.51 0-2.39-.45-3.4-1.6-.95-1.07-.83-2.6-.82-3.45V7.17c.08-.54.38-.82.89-.82s.8.28.86.82v4.16h.36V6.5c.07-.54.36-.8.88-.8s.8.26.87.8v4.83h.36V5.91c.05-.6.33-.91.85-.91"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Parry;
